import { UrlConstants } from "../url.constants";
export class ApiSystemSettingsConstants {
    static URL = UrlConstants.API_V2 + "SystemSetting";
    static FUNCTION_GET_PUBLIC_SYSTEM_SETTINGS = "GetPublicSystemSettings";
}
